module.exports = __webpack_public_path__ + "img/logo.9c73f7b3.png";